import { Component, OnInit } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { PageTitleService } from 'app/services/page-title/page-title.service';
import { CodaltComponent } from '../codalt.component';
import { LocalStorage } from '../local-storage.class';
import { CustomerProjectService } from '../services/customer-project/customer-project.service';
import { CustomerService } from '../services/customer/customer.service';
import { User } from '../user.interface';
import { Utils } from '../utils.class';

@Component({
    selector: 'app-customer-project-consumers',
    templateUrl: './customer-project-consumers.component.html',
    standalone: false,
})
export class CustomerProjectConsumersComponent extends CodaltComponent implements OnInit {
    displayedColumns = ['name', 'lastname', 'phone', 'email', 'updated_at'];

    currentSort: Sort = {
        active: 'name',
        direction: 'desc',
    };

    customerId: number;
    projectId: number;
    consumers: User[];

    constructor(
        private customerProjectService: CustomerProjectService,
        private customerService: CustomerService,
        private pageTitleService: PageTitleService
    ) {
        super();
    }

    ngOnInit(): void {
        this.pageTitleService.setTitle('Aanmeldingen bewoners');
        this.watchRouteParams(
            [this.RouteParamnames.customerId, this.RouteParamnames.projectId],
            ({ customerId, projectId }) => {
                this.customerId = +customerId;
                this.projectId = +projectId;

                // Klantgebied uit de route eerst in LocalStorage: de interceptor stuurt daaruit
                // current_customer_id mee, waarop getProject() filtert.
                this.subscriptions.add(
                    this.customerService.getSingle(this.customerId).subscribe(customer => {
                        LocalStorage.setCustomer(customer);

                        this.subscriptions.add(
                            this.customerProjectService
                                .getProject(this.projectId)
                                .subscribe(project =>
                                    this.pageTitleService.setTitle('Aanmeldingen bewoners', project.data.name)
                                )
                        );

                        this.subscriptions.add(
                            this.customerProjectService.getProjectConsumers(this.projectId).subscribe(consumer => {
                                this.consumers = consumer.data;
                                setTimeout(() => this.sortConsumers(this.currentSort));
                            })
                        );
                    })
                );
            }
        );
    }

    sortConsumers(sort?: Sort) {
        if (sort) {
            this.currentSort = sort;
        } else {
            sort = this.currentSort;
        }
        const data = this.consumers.slice();
        if (!sort.active || sort.direction === '') {
            this.consumers = data;
            return;
        }

        this.consumers = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            return Utils.compare(a[sort.active], b[sort.active], isAsc);
        });
    }
}
